import { render, staticRenderFns } from "./SettingsTabAccounting.vue?vue&type=template&id=4f6502e8"
import script from "./SettingsTabAccounting.vue?vue&type=script&lang=js"
export * from "./SettingsTabAccounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports